import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getIcon } from '../../util/icons';

class TrackImperativeTaskModal extends Component{

  componentWillMount(){

  }

  markComplete(){
    this.props.updateStatus('complete');
  }
  markFailed(){
    this.props.updateStatus('failed');
  }
  markIncomplete(){
    this.props.updateStatus('incomplete');
  }

  render(){

    const { imperativeName, imperativeTask, syncingImperativeTask, currentTaskStatus } = this.props;

    return (
      <div className="modal track-imperative-task">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            <div className="imperative">{imperativeName}</div>
            <h2>{imperativeTask.text}</h2>
          </div>
          {syncingImperativeTask &&
            <div className="modal-actions">
              <p className="updating-text">Updating checklist item...</p>
            </div>
          }
          {!syncingImperativeTask &&
            <div className="modal-actions">
              <button onClick={this.markComplete.bind(this)} className="button primary">Mark complete</button>
              <button onClick={this.markFailed.bind(this)} className="button align-with-normal-button-size danger-button button-sm">Mark at risk</button>

              {currentTaskStatus !== 'incomplete' &&
                <button onClick={this.markIncomplete.bind(this)} className="button align-with-normal-button-size grey-button button-sm">Mark incomplete</button>
              }
              {currentTaskStatus === 'incomplete' &&
                <button onClick={this.props.hide} className="button align-with-normal-button-size grey-button button-sm">Cancel</button>
              }
            </div>
          }
        </div>
      </div>
    )
  }
}

export default TrackImperativeTaskModal;



// WEBPACK FOOTER //
// ./src/components/modals/trackImperativeTask.js